import { GraphQLNonNull, GraphQLID } from 'graphql'
import { Context } from '../shared'
import {
  StatusApprovalWorkflowSettings,
  statusApprovalWorkflowSettingsType
} from '../types/status-approval-workflow'
import { ContrastGraphQLFieldConfig } from '..'

interface ApprovalWorkflowSettingsArgs {
  readonly organizationID: string
}

const approvalWorkflowSettingsQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export const approvalWorkflowSettings: ContrastGraphQLFieldConfig<
  any,
  Context,
  ApprovalWorkflowSettingsArgs,
  StatusApprovalWorkflowSettings
> = {
  description:
    'Get the organization approval workflow (vulnerability behavior) settings',
  type: new GraphQLNonNull(statusApprovalWorkflowSettingsType),
  args: approvalWorkflowSettingsQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID } = args

    const {
      enabled,
      status: statuses = [],
      severities = []
    } = await context.connector.get(
      `${organizationID}/approval-workflow/traces`
    )

    return {
      enabled,
      statuses,
      severities
    }
  }
}
